<script>
export default {
  setup() {
    const links = {
      0: {
        class: 'impressum-link',
        link: 'https://www.johanniter.de/impressum/#c105510',
        text: 'Impressum'
      },
      1: {
        class: 'datenschutz-link',
        link: 'https://www.johanniter.de/datenschutz/',
        text: 'Datenschutz'
      },
      2: {
        class: 'cookie-einstellungen-link',
        link: '#',
        text: 'Cookie-Einstellungen'
      }
    }
    const socialLinks = {
      0: {
        label: 'Facebook',
        iClass: 'fa fa-brands fa-facebook-f',
        link: 'https://www.johanniter.de/johanniter-auf-facebook/'
      },
      1: {
        label: 'Twitter X',
        iClass: 'fa fa-brands fa-x-twitter',
        link: 'https://twitter.com/johanniter'
      },
      2: {
        label: 'Instagram',
        iClass: 'fa fa-brands fa-instagram',
        link: 'https://www.johanniter.de/johanniter-auf-instagram/'
      },
      3: {
        label: 'YouTube',
        iClass: 'fa fa-brands fa-youtube',
        link: 'https://www.johanniter.de/johanniter-auf-youtube/'
      },
      4: {
        label: 'TikTok',
        iClass: 'fa fa-brands fa-tiktok',
        link: 'https://www.johanniter.de/johanniter-auf-tiktok/'
      },
      5: {
        label: 'LinkedIn',
        iClass: 'fa fa-brands fa-linkedin',
        link: 'https://www.johanniter.de/johanniter-auf-linkedin/'
      }
    }
    const openCookieBanner = () => {
      event.preventDefault();
      return UC_UI.showSecondLayer();
    }
    return {
      links,
      socialLinks,
      openCookieBanner
    }
  }
}
</script>

<template>
  <footer class="footer">
    <div class="footer-wrapper">
      <div class="footer--left-side">
        <div class="left-side-links">
          <ul class="links-list">
            <li v-for="link in links" :key="link.id">
              <a
                :class="link.class"
                :href="link.link"
                target="_blank"
                @click="link.class === 'cookie-einstellungen-link' ? openCookieBanner() : null"
              >
                {{ link.text }}
              </a>
            </li>
          </ul>
        </div>
        <div class="left-side-social-links">
          <a
            v-for="socialLink in socialLinks"
            :key="socialLink.id"
            :href="socialLink.link"
            target="_blank"
          >
            <i :key="socialLink.id" :class="socialLink.iClass"></i>
          </a>
        </div>
      </div>
      <div class="footer--right-side">
        <div class="right-side-logo"></div>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
  footer.footer {
    width: 100%;
    height: 350px;
    background: #000548;
    margin-top: 0;
  }
  .footer-wrapper {
    width: 73%;
    height: 85%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: end;
  }
  .footer--left-side {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }
  .footer--left-side .left-side-links ul.links-list {
    list-style: none;
    text-align: left;
  }
  .footer--left-side .left-side-links ul.links-list li {
    padding: 5px 0;
  }
  .footer--left-side .left-side-links ul.links-list li a {
    color: white;
    font-size: 16px;
    font-weight: 400;
    text-decoration: underline;
    line-height: 17.60px;
    word-wrap: break-word;
  }
  .footer--left-side .left-side-social-links {
    display: flex;
    gap: 15px;
  }
  .footer--left-side .left-side-social-links .fa:hover {
    opacity: 0.7;
  }
  .footer--left-side .left-side-social-links .fa {
    font-size: 20px;
    color: white;
    border: 1px solid white;
    border-radius: 50%;
  }
  .fa-facebook-f {
    padding: 10px 15px;
  }
  .fa-x-twitter {
    padding: 10px 10px;
  }
  .fa-instagram, .fa-tiktok, .fa-linkedin {
    padding: 10px 12px;
  }
  .fa-youtube {
    padding: 10px 9px;
  }
  .footer--right-side .right-side-logo {
    background-image: url('../assets/img/Johanniter_logo_footer.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    width: 90px;
    height: 90px;
  }
  @media only screen and (max-width: 600px) {
    .footer-wrapper {
      height: 100%;
      width: 90%;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: start;
      gap: 20px;
    }
  }
</style>
